export default __webpack_public_path__ + "static/media/jake-the-dog-tape-player-vertical.640a9779.gif";